/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1BannerPriorityListQueryResponse,
  GetApiV1BannerPriorityList401,
  GetApiV1BannerPriorityList500,
} from "../../types/bannerRegistroController/GetApiV1BannerPriorityList.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1BannerPriorityList } from "../../clients/bannerRegistroController/getApiV1BannerPriorityList.ts";

export const getApiV1BannerPriorityListQueryKey = () =>
  [{ url: "/api/v1/banner/priority-list" }] as const;

export type GetApiV1BannerPriorityListQueryKey = ReturnType<
  typeof getApiV1BannerPriorityListQueryKey
>;

export function getApiV1BannerPriorityListQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1BannerPriorityListQueryKey();
  return queryOptions<
    GetApiV1BannerPriorityListQueryResponse,
    ResponseErrorConfig<
      GetApiV1BannerPriorityList401 | GetApiV1BannerPriorityList500
    >,
    GetApiV1BannerPriorityListQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1BannerPriorityList({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna as prioridades possíveis do banner (enum EBannerPriority) para dropdown. **(Requer Authorization para autenticação)**
 * @summary Listar prioridades do banner (Requer Authorization para autenticação)
 * {@link /api/v1/banner/priority-list}
 */
export function useGetApiV1BannerPriorityList<
  TData = GetApiV1BannerPriorityListQueryResponse,
  TQueryData = GetApiV1BannerPriorityListQueryResponse,
  TQueryKey extends QueryKey = GetApiV1BannerPriorityListQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1BannerPriorityListQueryResponse,
        ResponseErrorConfig<
          GetApiV1BannerPriorityList401 | GetApiV1BannerPriorityList500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1BannerPriorityListQueryKey();

  const query = useQuery(
    {
      ...getApiV1BannerPriorityListQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1BannerPriorityList401 | GetApiV1BannerPriorityList500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
